import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!sessionStorage.getItem("pwa-dismissed")) setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setVisible(false));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    sessionStorage.setItem("pwa-dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto flex max-w-md items-center gap-3 rounded-2xl border border-[#ff6a00]/40 bg-[#151b2b] p-3 shadow-2xl"
    >
      <img src="/icon-192.png" alt="" className="h-11 w-11 rounded-xl" />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-bold text-white">Installer CHAP CHAP</div>
        <div className="text-xs text-slate-400">Accès rapide depuis votre écran d'accueil</div>
      </div>
      <button
        data-testid="pwa-install-btn"
        onClick={install}
        className="flex items-center gap-1.5 rounded-xl bg-[#ff6a00] px-3 py-2 text-sm font-bold text-white hover:bg-[#e85f00]"
      >
        <Download className="h-4 w-4" /> Installer
      </button>
      <button data-testid="pwa-dismiss-btn" onClick={dismiss} className="text-slate-500 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
